import {IUserInfo, UserInfo} from "../model/UserInfo.model";
import {ToastType} from "../components/common/Toast.component";

export interface IToastNotification {
    message: string;
    type: ToastType;
}

export const TOAST_NOTIFICATION_TIMEOUT_MS = 3000;

export const extractApiErrorMessage = (error: unknown): string => {
    if (!error) { return ""; }
    const err = error as {message?: unknown};
    if (typeof err.message === "string") { return err.message; }
    if (err.message !== null && typeof err.message === "object") {
        const nested = err.message as {message?: string};
        return nested.message ?? "";
    }
    return "";
};

export const removePlanFromUsers = (users: IUserInfo[], arbtSecurityId: string, planId: number): UserInfo[] => {
    return users.map((user) => {
        if (user.arbtSecurityId === arbtSecurityId) {
            return new UserInfo(
                user.firstName,
                user.lastName,
                user.email,
                user.lastLoginDate,
                user.userType,
                user.arbtSecurityId,
                user.planIds.filter((id) => id !== planId),
            );
        }

        return user;
    });
};
